// extracted by mini-css-extract-plugin
export var container = "_hb-1";
export var cornerButtonContainer = "_hb-6";
export var disabled = "_hb-2";
export var dragActive = "_hb-3";
export var fileContainer = "_hb-5";
export var hiddenInput = "_hb-4";
export var widthContainer = "_hb-0";